import { Search, X } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "./ui/select";

const SelectField = ({ label, value, onChange, options, testid }) => (
  <div className="flex flex-col gap-1.5">
    <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
      {label}
    </label>
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger
        data-testid={testid}
        className="rounded-none border border-[#D1D5DB] bg-white h-11 focus:ring-2 focus:ring-[#002FA7] focus:ring-offset-0 text-sm"
      >
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="rounded-none border border-[#0A0A0A]">
        {options.map((opt) => (
          <SelectItem key={opt} value={opt} className="rounded-none font-mono text-sm">
            {opt}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  </div>
);

export const FilterBar = ({
  q, setQ,
  type, setType,
  category, setCategory,
  state, setState,
  role, setRole,
  detailed, setDetailed,
  meta,
  onExport,
  onReset,
  total,
  isExporting,
}) => {
  const withAll = (arr) => ["All", ...(arr || [])];

  return (
    <div
      data-testid="filter-bar"
      className="border border-[#0A0A0A] bg-white p-6 md:p-8"
    >
      <div className="flex flex-col lg:flex-row lg:items-end gap-6">
        {/* Search */}
        <div className="flex-1 flex flex-col gap-1.5">
          <label className="font-mono text-[10px] uppercase tracking-[0.2em] text-[#4B5563]">
            Search institution
          </label>
          <div className="relative">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#4B5563]" />
            <input
              data-testid="search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search 9,381 banks & NBFCs..."
              className="w-full pl-10 pr-10 py-3 border border-[#D1D5DB] focus:outline-none focus:ring-2 focus:ring-[#002FA7] bg-white text-sm"
            />
            {q && (
              <button
                type="button"
                aria-label="Clear search"
                onClick={() => setQ("")}
                className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-[#4B5563] hover:text-[#0A0A0A]"
              >
                <X className="w-4 h-4" />
              </button>
            )}
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-5 gap-4 lg:flex-[2]">
          <SelectField
            label="Type"
            value={type}
            onChange={setType}
            options={withAll(meta?.types)}
            testid="filter-type"
          />
          <SelectField
            label="Category"
            value={category}
            onChange={setCategory}
            options={withAll(meta?.categories)}
            testid="filter-category"
          />
          <SelectField
            label="State"
            value={state}
            onChange={setState}
            options={withAll(meta?.states)}
            testid="filter-state"
          />
          <SelectField
            label="Role"
            value={role}
            onChange={setRole}
            options={withAll(meta?.roles)}
            testid="filter-role"
          />
          <SelectField
            label="Verified"
            value={detailed}
            onChange={setDetailed}
            options={["All", "verified", "unverified"]}
            testid="filter-detailed"
          />
        </div>
      </div>

      <div className="mt-6 pt-6 border-t border-[#E5E7EB] flex flex-col sm:flex-row sm:items-center justify-between gap-4">
        <div className="flex items-center gap-4">
          <span className="font-mono text-xs uppercase tracking-[0.15em] text-[#4B5563]">
            <span className="text-[#0A0A0A] font-bold" data-testid="result-count">{total.toLocaleString()}</span> results
          </span>
          <button
            type="button"
            onClick={onReset}
            data-testid="reset-filters-button"
            className="font-mono text-xs uppercase tracking-[0.15em] text-[#4B5563] hover:text-[#FF3333] transition-colors underline underline-offset-4"
          >
            Reset filters
          </button>
        </div>
      </div>
    </div>
  );
};
